import {
  Autocomplete,
  Box,
  Button,
  CardMedia,
  CircularProgress,
  createFilterOptions,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";

import { useCallback, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import dayjs from "dayjs";
import { Image } from "@mui/icons-material";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_TICKET,
  DELETE_TICKET_PICTURES,
  FETCH_COMPANIES,
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_BY_NAME_NEW,
  FETCH_TICKETS_TYPE,
  SAVE_COMPANIES,
  SAVE_TICKET,
  SAVE_TICKET_TYPES
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import VerifiedIcon from "@mui/icons-material/Verified";
import WarningIcon from "@mui/icons-material/Warning";
import UseDebounce from "../common/UseDebounce";
import Removeduplicates from "../common/Removeduplicate";
import { English } from "../../constant/EnglishFallback";
import PromptModal from "../common/PromptModal";
import CompanySelectModal from "../common/CompanySelectModal";
const AddTicket = (props) => {
  const filter = createFilterOptions();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [ticketsType, setTicketsType] = useState([]);
  const [frontImgFile, setFrontImgFile] = useState("");
  const [backImgFile, setBackImgFile] = useState("");
  const [issuedDateopen, setIssuedDateopen] = useState(false);
  const [expiryDateopen, setExpiryDateopen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [delLoading, setDelLoading] = useState(false);
  const [ticketType, setTickettype] = useState({ typeId: 0, typeName: "" });
  const [selectType, setSelecttype] = useState(false);
  const [typeLoading, setTypeLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [issuedBy, setIssuedby] = useState({ issuedById: 0, issuedByname: "" });
  const [selectCompany, setSelectcompany] = useState(false);
  const [companyLoading, setCompanyLoading] = useState(false);
  const [openCompanySelectModal, setOpenCompanySelectModal] = useState(false);

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [deleteTicketModel, setDeleteTicketModel] = useState(false);
  const [ticketData, setTicketData] = useState({
    id: 0,
    frontPictureUrl: "",
    isFrontDeleted: false,
    backPictureUrl: "",
    isBackDeleted: false,
    issuedOn: null,
    expiry: null,
    ticketId: ""
  });
  const navigate = useNavigate();

  const {
    BUTTON_TEXT_ADD_TICKET = English?.Tickets?.BUTTON_TEXT_ADD_TICKET,
    TEXT_EDIT_TICKET = English?.Tickets?.TEXT_EDIT_TICKET,
    TEXT_EXPIRING_DATE_OPTIONAL = English?.Tickets?.TEXT_EXPIRING_DATE_OPTIONAL,
    TEXT_ID_OPTIONAL = English?.Tickets?.TEXT_ID_OPTIONAL,
    TEXT_ISSUED_BY = English?.Tickets?.TEXT_ISSUED_BY,
    TEXT_ISSUED_DATE = English?.Tickets?.TEXT_ISSUED_DATE,
    TEXT_TICKET_INFO = English?.Tickets?.TEXT_TICKET_INFO,
    TEXT_TICKET_TYPE = English?.Tickets?.TEXT_TICKET_TYPE,
    TEXT_UPLOAD_BACK = English?.Tickets?.TEXT_UPLOAD_BACK,
    TEXT_TICKET_OPTIONAL = English?.Tickets?.TEXT_TICKET_OPTIONAL,
    TEXT_UPLOAD_FRONT = English?.Tickets?.TEXT_UPLOAD_FRONT,
    TEXT_DELETE_TICKETS_TITLE = English?.Tickets?.TEXT_DELETE_TICKETS_TITLE,
    TEXT_DELETE_TICKETS_DESC = English?.Tickets?.TEXT_DELETE_TICKETS_DESC,
    BUTTON_MODAL_DELETE = English?.Tickets?.BUTTON_MODAL_DELETE,
    TEXT_ADD = English?.Tickets?.TEXT_ADD
  } = multiLanguageData?.Tickets || {};

  useEffect(() => {
    if (props?.ticketFlag === "edit" || props?.ticketFlag === "home") {
      const {
        id,
        frontPictureUrl,
        backPictureUrl,
        issuedOn,
        expiry,
        ticketId,
        ticketTypeId,
        ticketType,
        issuedById,
        issuedBy
      } = props?.editTicketItemDetails;
      setTicketData({
        id: id,
        frontPictureUrl: frontPictureUrl,
        isFrontDeleted: false,
        backPictureUrl: backPictureUrl,
        isBackDeleted: false,
        issuedOn: issuedOn,
        expiry: expiry,
        ticketId: ticketId
      });
      setTickettype({
        typeId: ticketTypeId,
        typeName: ticketType
      });
      setIssuedby({
        issuedById: issuedById,
        issuedByname: issuedBy
      });
    }
  }, [props?.editTicketItemDetails]);

  const debouncedTickettype = UseDebounce(ticketType?.typeName, 400);
  useEffect(() => {
    if (debouncedTickettype !== undefined && debouncedTickettype !== null && debouncedTickettype !== "") {
      fetchTicketType(debouncedTickettype);
    } else if (selectType) {
      fetchTicketType("");
    }
  }, [debouncedTickettype, selectType]);

  const fetchTicketType = useCallback(async (searchValue) => {
    setTypeLoading(true);
    try {
      const fetchObj = {
        SearchList: [{ manufacturer: false }, { Name: searchValue || "" }]
      };
      let getTickettype = await Postrequestcall(
        FETCH_TICKETS_TYPE,
        fetchObj,
        loginData?.accessToken
      );
      if (getTickettype.status === 201) {
        let getTypes = getTickettype?.data?.data.map((item) => {
          return {
            typeId: item.id,
            typeName: item.name
          };
        });
        setTicketsType(getTypes);
      }
    } catch (error) {
      console.log("fetchTicketType-> Error When Fetching Ticket Types: ", error);
    } finally {
      setTypeLoading(false);
    }
  }, [loginData?.accessToken]);

  const debouncedCompany = UseDebounce(issuedBy?.issuedByname, 400);

  useEffect(() => {
    if (debouncedCompany !== undefined && debouncedCompany !== null && debouncedCompany !== "") {
      getCompanies(debouncedCompany);
    } else if (selectCompany) {
      getCompanies("");
    }
  }, [debouncedCompany, selectCompany]);



  const getCompanies = useCallback(async (searchValue) => {
    setCompanyLoading(true);
    try {
      // OLD API: FETCH_COMPANIES (commented, do not delete)
      // let getObject = {
      //   IncludeRecordNr: true,
      //   NrOfRecPerPage: 0,
      //   SearchList: [{ manufacturer: false }, { Name: searchValue }],
      //   SortList: [{ FieldName: "Name", Direction: "ASC" }]
      // };
      // const getResponse = await Postrequestcall(FETCH_COMPANIES, getObject, loginData?.accessToken);
      
      // OLD API: FETCH_COMPANIES_2 (commented, do not delete)
      // let getObject = {
      //   UserId: loginData?.userInformation?.UserId ?? 0,
      //   SearchString: searchValue || "",
      //   PageNumber: 1,
      //   PageSize: 50,
      //   Manufacturer: false,
      //   Id: 0
      // };
      // const getResponse = await Postrequestcall(FETCH_COMPANIES_2, getObject, loginData?.accessToken);

      // NEW API: FETCH_COMPANIES_BY_NAME_NEW (active)
      let getObject = {
        PageNr: 1,
        NrOfRecPerPage: 50,
        FullSearch: searchValue || "",
        UserId: loginData?.userInformation?.UserId ?? 0,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [{}],
        SortList: [
          { FieldName: "Verified", Direction: "DESC" },
          { FieldName: "Name", Direction: "ASC" }
        ]
      };
      const getResponse = await Postrequestcall(FETCH_COMPANIES_BY_NAME_NEW, getObject, loginData?.accessToken);
      if (getResponse?.data?.data) {
        let getUpdatedlist = Removeduplicates(getResponse?.data?.data || [], "name");
        getUpdatedlist = getUpdatedlist.map((item) => {
          return {
            ...item,
            issuedById: item?.id,
            issuedByname: item?.name
          };
        });
        setCompanies(getUpdatedlist);
      }
    } catch (error) {
      console.log("getCompanies-> Error When Fetching Companies: ", error);
    } finally {
      setCompanyLoading(false);
    }
  }, [loginData?.accessToken, loginData?.userInformation?.UserId]);



  const handleChooseFile = (event, param) => {
    const file = event.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      if (param === "isFrontImgFile") {
        setTicketData({
          ...ticketData,
          frontPictureUrl: url
        });
        setFrontImgFile(file);
      } else {
        setTicketData({
          ...ticketData,
          backPictureUrl: url
        });
        setBackImgFile(file);
      }
      event.target.value = "";
    }
  };

  const handleRemoveImage = (param) => {
    if (param === "isFrontImgFile") {
      setTicketData({
        ...ticketData,
        frontPictureUrl: ""
      });
      setFrontImgFile("");
    } else {
      setTicketData({
        ...ticketData,
        backPictureUrl: "",
        isBackDeleted: true
      });
      setBackImgFile("");
    }
  };

  const onTickettypechange = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    if (inputValue.trim() === "" && inputValue !== "") {
      return;
    }
    if (inputValue !== "") {
      setSelecttype(true);
    } else {
      setSelecttype(false);
    }
    setTickettype({
      ...ticketType,
      typeName: inputValue
    });
  };

  const onTickettypeselect = (event, newValue) => {
    setSelecttype(false);
    if (newValue?.inputValue) {
      let getObj = {
        typeId: 0,
        typeName: newValue?.inputValue
      };
      setTickettype(getObj);
    } else if (newValue === null) {
      setTickettype({
        ...ticketType,
        typeId: 0,
        typeName: ""
      });
    } else {
      setTickettype({
        ...ticketType,
        typeId: newValue?.typeId,
        typeName: newValue?.typeName
      });
    }
  };

  const onCleartickettype = () => {
    setSelecttype(false);
    setTickettype({
      ...ticketType,
      typeId: 0,
      typeName: ""
    });
  };

  const handleInputChange = (e, field) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");

    setTicketData({
      ...ticketData,
      [field]: inputValue
    });
  };
  const onCompanychange = async (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    if (inputValue !== "") {
      setSelectcompany(true);
    } else {
      setSelectcompany(false);
    }
    setIssuedby({
      ...issuedBy,
      issuedByname: inputValue
    });
  };

  const onCompanyselect = (event, newValue) => {
    setSelectcompany(false);
    if (newValue?.recordStatusId === 3) {
      alert("This company is reported");
      return;
    }
    if (newValue?.inputValue) {
      let getObj = {
        issuedById: 0,
        issuedByname: newValue?.inputValue
      };
      setIssuedby(getObj);
    } else if (newValue === null) {
      setIssuedby({
        ...issuedBy,
        issuedById: 0,
        issuedByname: ""
      });
    } else {
      setIssuedby({
        ...issuedBy,
        issuedById: newValue?.issuedById || newValue?.id,
        issuedByname: newValue?.issuedByname || newValue?.name
      });
    }
  };

  const onClearcompany = () => {
    setSelectcompany(false);
    setIssuedby({
      ...issuedBy,
      issuedById: 0,
      issuedByname: ""
    });
  };

  const handleDateChange = (newDate, field) => {
    setTicketData({
      ...ticketData,
      [field]: newDate
    });
    field === "issuedOn" ? setIssuedDateopen(false) : setExpiryDateopen(false);
  };

  const isAllDone = () => {
    const issuedDate = dayjs(ticketData?.issuedOn);
    const expiryDate = dayjs(ticketData?.expiry);

    const isExpiryValid =
      ticketData?.expiry === null ||
      (issuedDate.isValid() && expiryDate.isValid() && !expiryDate.isBefore(issuedDate, "day"));

    return (
      ticketType.typeName?.length > 1 &&
      issuedBy.issuedByname?.length > 1 &&
      ticketData.issuedOn !== null &&
      ticketData.frontPictureUrl !== "" &&
      isExpiryValid
    );
  };

  const handleCloseModal = () => {
    props.closeModal();
    if (props?.ticketFlag == "edit") {
      props?.setShowTicket(true);
      props?.setEditTicketData(props?.editTicketItemDetails);
      props?.setTicketFlag("edit");
    } else {
      props?.setTicketFlag("");
    }
  };
  const handleSaveTicket = async () => {
    try {
      setLoading(true);
      let typeId = ticketType?.typeId;
      let issuedId = issuedBy.issuedById;
      if (ticketData?.isBackDeleted && ticketData?.id !== 0) {
        const obj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: false,
          ReturnRecordError: true,
          SoftDelete: false,
          DeleteList: [{ Id: ticketData?.id, BackPictureUrl: "" }]
        };
        await Postrequestcall(DELETE_TICKET_PICTURES, obj, loginData?.accessToken);
      }
      if (typeId == 0) typeId = await saveTickettypes("ticket type");
      if (issuedId == 0) issuedId = await saveTickettypes("issued by");
      let ticketDataObj = new FormData();
      ticketDataObj.append("Id", ticketData?.id ?? 0);
      ticketDataObj.append("TicketTypeId", typeId);
      ticketDataObj.append(
        "Expiry",
        ticketData?.expiry === null ? "" : dayjs(ticketData?.expiry).toISOString()
      );
      ticketDataObj.append("TicketId", ticketData?.ticketId || "");
      ticketDataObj.append("IssuedById", issuedId);
      ticketDataObj.append(
        "IssuedOn",
        ticketData?.issuedOn === null ? "" : dayjs(ticketData?.issuedOn).toISOString()
      );
      ticketDataObj.append("ImageFront", frontImgFile);
      ticketDataObj.append("ImageBack", backImgFile);
      ticketDataObj.append("ModifiedBy", loginData?.userInformation?.UserId);

      const res = await Fileuploadrequestcall(SAVE_TICKET, ticketDataObj, loginData?.accessToken);

      if (res.status === 201) {
        if (props?.ticketFlag === "edit") {
          props.setShowTicket(true);
          props?.setTicketFlag("editSave");
          props?.setFromFlag("viewModalSave");
        } else {
          props.fetchUserTicket();
        }
        props?.removeSelectedTickets();
        props.closeModal();
        setLoading(false);
      }
    } catch (error) {
      console.error("handleSaveTicket-> Error When Saving Ticket: ", error);
    } finally {
      setLoading(false);
    }
  };

  const saveTickettypes = async (options) => {
    try {
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: options === "ticket type" ? ticketType.typeName : issuedBy?.issuedByname,
            ModifiedBy: loginData?.userInformation?.UserId,
            RecordStatusId: 1,
            Manufacturer: false
          }
        ]
      };
      if (options === "ticket type") {
        const getResponse = await Postrequestcall(
          SAVE_TICKET_TYPES,
          getObject,
          loginData?.accessToken
        );
        if (getResponse?.status === 201) {
          if (getResponse?.data?.data?.length > 0) {
            return getResponse?.data?.data[0]?.objData?.id;
          }
        }
      } else {
        const getResponse = await Postrequestcall(
          SAVE_COMPANIES,
          getObject,
          loginData?.accessToken
        );
        if (getResponse?.status === 201) {
          if (getResponse?.data?.data?.length > 0) {
            return getResponse?.data?.data[0]?.objData?.id;
          }
        }
      }
    } catch (error) {}
  };

  const handleDeleteTicket = async () => {
    setDelLoading(true);
    try {
      const deleteObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        DeleteList: [
          {
            Id: ticketData.id,
            modifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const response = await Postrequestcall(DELETE_TICKET, deleteObj, loginData?.accessToken);
      if (response?.status === 201) {
        props.fetchUserTicket();
        props?.removeSelectedTickets();
        props.closeModal();
      }
      setDeleteTicketModel(false);
      setDelLoading(false);
    } catch (error) {
      setDelLoading(false);
    }
  };

  const handleCloseDeleteModal = () => {
    setDeleteTicketModel(false);
  };

  return (
    <>
      {deleteTicketModel && (
        <PromptModal
          isOpen={deleteTicketModel}
          onClose={handleCloseDeleteModal}
          title={TEXT_DELETE_TICKETS_TITLE}
          desc={TEXT_DELETE_TICKETS_DESC}
          redButtonText={BUTTON_MODAL_DELETE}
          onRedButtonClick={handleDeleteTicket}
        />
      )}
      <Modal
        open={props?.openModal}
        style={{ zIndex: 1500 }}
        sx={{ zIndex: 1500 }}
      >
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6">
              {props?.ticketFlag === "edit" || props?.ticketFlag === "home"
                ? TEXT_EDIT_TICKET
                : BUTTON_TEXT_ADD_TICKET}
            </Typography>
            <Stack direction={"row"}>
              {props?.ticketFlag === "edit" || props?.ticketFlag === "home" ? (
                <IconButton
                  disabled={delLoading || loading}
                  loading={delLoading}
                  color="secondary"
                  onClick={() => setDeleteTicketModel(true)}
                  // onClick={handleDeleteTicket}
                >
                  <DeleteIcon />
                </IconButton>
              ) : null}
              <IconButton
                loading={loading}
                disabled={(!isAllDone() && !loading) || delLoading}
                color="primary"
                onClick={handleSaveTicket}>
                <SaveIcon />
              </IconButton>
              <IconButton onClick={handleCloseModal}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>
          {/* {loadingViewModel ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "450px"
              }}>
              <Loader />
            </Box>
          ) : ( */}
          <Box>
            <Stack direction={"column"} spacing={1.5}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 6 }}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "145px",
                      position: "relative",
                      display: "inline-block"
                    }}>
                    {ticketData.frontPictureUrl ? (
                      <>
                        <label htmlFor="upload-front">
                          <CardMedia
                            component="img"
                            loading="lazy"
                            image={ticketData.frontPictureUrl}
                            alt="Ticket Front"
                            sx={{
                              height: "145px",
                              cursor: "pointer",
                              borderRadius: "5px"
                            }}
                          />
                        </label>
                        <input
                          id="upload-front"
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) => handleChooseFile(e, "isFrontImgFile")}
                        />
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveImage("isFrontImgFile")}
                          sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            backgroundColor: "rgba(255,255,255,0.7)",
                            "&:hover": { backgroundColor: "rgba(255,255,255,1)" }
                          }}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </>
                    ) : (
                      <Button
                        component="label"
                        variant="text"
                        size="large"
                        startIcon={<Image />}
                        sx={{
                          width: "100%",
                          height: "145px",
                          color: "GrayText",
                          borderRadius: "5px",
                          backgroundColor: "lightgray",
                          textTransform: "none"
                        }}>
                        {TEXT_UPLOAD_FRONT}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) => handleChooseFile(e, "isFrontImgFile")}
                        />
                      </Button>
                    )}
                  </Box>
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "145px",
                      position: "relative",
                      display: "inline-block"
                    }}>
                    {ticketData?.backPictureUrl ? (
                      <>
                        <label htmlFor="upload-back">
                          <CardMedia
                            loading="lazy"
                            component="img"
                            image={ticketData?.backPictureUrl}
                            alt="Ticket Back"
                            sx={{
                              height: "145px",
                              cursor: "pointer",
                              borderRadius: "5px"
                            }}
                          />
                        </label>
                        <input
                          id="upload-back"
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) => handleChooseFile(e, "isBackImgFile")}
                        />
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveImage("isBackImgFile")}
                          sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            backgroundColor: "rgba(255,255,255,0.7)",
                            "&:hover": { backgroundColor: "rgba(255,255,255,1)" }
                          }}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </>
                    ) : (
                      <Button
                        component="label"
                        variant="text"
                        size="large"
                        startIcon={<Image />}
                        sx={{
                          width: "100%",
                          height: "145px",
                          color: "GrayText",
                          borderRadius: "5px",
                          backgroundColor: "lightgray",
                          textTransform: "none"
                        }}>
                        {`${TEXT_UPLOAD_BACK} (${TEXT_TICKET_OPTIONAL})`}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) => handleChooseFile(e, "isBackImgFile")}
                        />
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
              <Divider />
              <Stack>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {" "}
                  {TEXT_TICKET_INFO}{" "}
                </Typography>
              </Stack>
              <Stack spacing={1.5}>
                <Autocomplete
                  inputValue={ticketType?.typeName || ""}
                  open={ticketType?.typeName?.length > 1 && selectType}
                  options={ticketsType}
                  fullWidth
                  loading={typeLoading}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    if (option?.typeName) {
                      return option?.typeName;
                    }
                    return option?.typeName;
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const inputValue = params?.inputValue || "";
                    const isExisting = options?.some((option) => inputValue?.toLowerCase() === option?.typeName?.toLowerCase());
                    if (inputValue !== "" && !isExisting && !typeLoading) {
                      filtered.push({
                        inputValue,
                        typeName: `${TEXT_ADD} "${inputValue}"`
                      });
                    }
                    return filtered;
                  }}
                  renderOption={(props, option) => <li {...props}>{option?.typeName}</li>}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="typeName"
                      onChange={onTickettypechange}
                      label={TEXT_TICKET_TYPE}
                      InputProps={{
                        ...(params.InputProps || {}),
                        endAdornment: (
                          <>
                            {typeLoading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params?.InputProps?.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                  onChange={(event, newValue) => onTickettypeselect(event, newValue)}
                  clearOnBlur={true}
                  freeSolo
                  clearIcon={<CloseIcon onClick={onCleartickettype} />}
                />

                <TextField
                  fullWidth
                  id="ID#"
                  label={TEXT_ID_OPTIONAL}
                  variant="outlined"
                  onChange={(e) => handleInputChange(e, "ticketId")}
                  value={ticketData.ticketId || ""}
                />

                <TextField
                  fullWidth
                  name="issuedBy"
                  label={TEXT_ISSUED_BY}
                  value={issuedBy?.issuedByname || ""}
                  onClick={() => setOpenCompanySelectModal(true)}
                  InputProps={{
                    readOnly: true,
                    endAdornment: issuedBy?.issuedByname ? (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            onClearcompany();
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }}
                  sx={{ cursor: "pointer", "& input": { cursor: "pointer" } }}
                />

                <CompanySelectModal
                  open={openCompanySelectModal}
                  onClose={() => setOpenCompanySelectModal(false)}
                  onSelect={(company) => {
                    if (company?.recordStatusId === 3) {
                      alert(company?.manufacturer ? "This manufacturer is reported" : "This company is reported");
                      return;
                    }
                    setIssuedby({
                      ...issuedBy,
                      issuedById: company?.id ?? 0,
                      issuedByname: company?.name ?? ""
                    });
                    setOpenCompanySelectModal(false);
                  }}
                  selectedId={issuedBy?.issuedById}
                  title="Select Company"
                  placeholder="Search company..."
                />


                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box
                    onClick={() => setIssuedDateopen(true)}
                    sx={{
                      height: "50px",
                      // backgroundColor: "#e4e4e4",
                      border:"1px solid lightgrey",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 15px",
                      cursor: "pointer"
                    }}>
                    <span>
                      {ticketData?.issuedOn && dayjs(ticketData?.issuedOn)
                        ? dayjs(ticketData?.issuedOn).isSame(dayjs(), "day")
                          ? `${dayjs(ticketData?.issuedOn).format("MMM DD, YYYY")} (Today)`
                          : dayjs(ticketData?.issuedOn).format("MMM DD, YYYY")
                        : "Start Date"}
                    </span>
                    <InsertInvitationIcon />
                  </Box>

                  {/* Hidden DatePicker for functionality */}
                  <MobileDatePicker
                    open={issuedDateopen}
                    onOpen={() => setIssuedDateopen(true)}
                    onClose={() => setIssuedDateopen(false)}
                    format="MMM DD, YYYY"
                    value={
                      ticketData?.issuedOn === null
                        ? ticketData?.issuedOn
                        : dayjs(ticketData.issuedOn)
                    }

                    onChange={(newValue) => handleDateChange(newValue, "issuedOn")}
                    // defaultValue={dayjs()}
                    sx={{ display: "none" }} // Hide the actual picker input
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box
                    onClick={() => setExpiryDateopen(true)}
                    sx={{
                      height: "50px",
                      // backgroundColor: "#e4e4e4",
                      border:"1px solid lightgrey",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 15px",
                      cursor: "pointer"
                    }}>
                    <span>
                      {ticketData?.expiry && dayjs(ticketData?.expiry)
                        ? dayjs(ticketData?.expiry).isSame(dayjs(), "day")
                          ? `${dayjs(ticketData?.expiry).format("MMM DD, YYYY")} (Today)`
                          : dayjs(ticketData?.expiry).format("MMM DD, YYYY")
                        : "Expiry Date (Optional)"}
                    </span>
                    <InsertInvitationIcon />
                  </Box>

                  {/* Hidden DatePicker for functionality */}
                  <MobileDatePicker
                    open={expiryDateopen}
                    onOpen={() => setExpiryDateopen(true)}
                    onClose={() => setExpiryDateopen(false)}
                    shouldDisableDate={(date) => {
                      const issuedDate = dayjs(ticketData?.issuedOn);
                      return issuedDate.isValid() && date.isBefore(issuedDate, "day");
                    }}
                    format="MMM DD, YYYY"
                    value={
                      ticketData?.expiry === null ? ticketData?.expiry : dayjs(ticketData?.expiry)
                    }

                    onChange={(newValue) => handleDateChange(newValue, "expiry")}
                    // defaultValue={dayjs()}
                    label="Expiry Date"
                    sx={{ display: "none" }} // Hide the actual picker input
                  />
                </LocalizationProvider>
              </Stack>
            </Stack>
          </Box>
          {/* )} */}
        </Box>
      </Modal>
    </>
  );
};

export default AddTicket;
